import { render, staticRenderFns } from "./ProductWishlistButton.vue?vue&type=template&id=17e65d4e&"
import script from "./ProductWishlistButton.vue?vue&type=script&lang=js&"
export * from "./ProductWishlistButton.vue?vue&type=script&lang=js&"
import style0 from "./ProductWishlistButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports